module.exports = __webpack_public_path__ + "img/debt.75459361.svg";